import { createTRPCClient, httpBatchLink } from '@trpc/client';
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query';
import { QueryClient } from '@tanstack/react-query';
import superjson from 'superjson';
import type { AppRouter } from '@/server/trpc/router';

function getBaseUrl() {
  if (typeof window !== 'undefined') return '';
  if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`;
  // Portless sets PORT to a random 4000–4999 backend. Ignore .env PORT=3000.
  const port = Number(process.env.PORT);
  if (Number.isInteger(port) && port >= 4000 && port <= 4999) {
    return `http://127.0.0.1:${port}`;
  }
  if (process.env.NODE_ENV === 'production') return 'http://127.0.0.1:3000';
  return 'https://cdbattaglia.localhost';
}

const linkConfig = httpBatchLink({
  url: `${getBaseUrl()}/api/trpc`,
  transformer: superjson,
});

export const vanillaClient = createTRPCClient<AppRouter>({
  links: [linkConfig],
});

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  });
}

export const trpc = createTRPCOptionsProxy<AppRouter>({
  client: vanillaClient,
  queryClient: makeQueryClient,
});
